export const SignupTileProgram = {
  bindings: {
    product: '<',
  },

  template: `
    <div class="d-flex align-items-center"
      ng-class="'theme-' + $ctrl.product.name | kebabCase">
      <div class="theme-program-overview d-none d-sm-block"></div>
      <div class="signup-tile-content">
        <span class="h4 d-none d-sm-block">{{ $ctrl.product.name }}</span>
        <strong class="d-sm-none">{{ $ctrl.product.name }}</strong>
        <span class="d-block">
          by {{ $ctrl.product.author.screenName }}
        </span>
      </div>
      <div class="ml-auto">
        <div class="cost" ng-hide="$ctrl.product.discountInCents > 0">
          {{ $ctrl.product.priceInCents / 100 | currency }}
        </div>
        <div class="cost" ng-show="$ctrl.product.discountInCents > 0">
          {{ $ctrl.product.totalInCents / 100 | currency }}
          <del class="text-warning">
            {{ $ctrl.product.priceInCents / 100 | currency }}
          </del>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupTileProgram.js